
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdminDocPageClassificationForm": [
      "AdminFinancialReport",
      "AdminPhotoIdentification",
      "AdminTaxCharitableContribution",
      "AdminTaxF1040",
      "AdminTaxF1065SchK1",
      "AdminTaxF1065SchK3",
      "AdminTaxF1065SchK3PartI",
      "AdminTaxF1065SchK3PartII",
      "AdminTaxF1065SchK3PartIII",
      "AdminTaxF1065SchK3PartIV",
      "AdminTaxF1065SchK3PartIX",
      "AdminTaxF1065SchK3PartX",
      "AdminTaxF1095a",
      "AdminTaxF1098",
      "AdminTaxF1098e",
      "AdminTaxF1098t",
      "AdminTaxF1099b",
      "AdminTaxF1099div",
      "AdminTaxF1099g",
      "AdminTaxF1099int",
      "AdminTaxF1099misc",
      "AdminTaxF1099nec",
      "AdminTaxF1099oid",
      "AdminTaxF1099q",
      "AdminTaxF1099r",
      "AdminTaxF1099ssa",
      "AdminTaxF1120sSchK1",
      "AdminTaxInvestmentExpense",
      "AdminTaxPropertyTaxBill",
      "AdminTaxVehicleRegistrationBill",
      "AdminTaxW2"
    ],
    "AdminEsignRequestSubject": [
      "AdminAuthorization",
      "AdminReassessmentAppeal",
      "AdminTaxR706",
      "AdminTaxR1040",
      "AdminTaxR1041",
      "AdminTaxR1065",
      "AdminTaxR1120",
      "AdminTaxR1120s"
    ],
    "AdminIdEntity": [
      "AdminIdCorporation",
      "AdminIdIndividual",
      "AdminIdLimitedPartnership",
      "AdminIdLlc",
      "AdminIdTrust"
    ],
    "AdminMonitorSuppressionMonitorable": [
      "AdminBusinessActivity",
      "AdminIdIndividual",
      "AdminRealPropertyAccount"
    ],
    "AdminQboConnectable": [
      "AdminBusinessActivity",
      "AdminRealPropertyAccount"
    ],
    "AdminTaxReturn": [
      "AdminTaxR706",
      "AdminTaxR1040",
      "AdminTaxR1041",
      "AdminTaxR1065",
      "AdminTaxR1120",
      "AdminTaxR1120s"
    ],
    "AdminTaxSource": [
      "AdminCchSnapshot",
      "AdminDoc",
      "AdminTaxTranscriptWageAndIncomeSection"
    ],
    "TaxWorkpaper": [
      "TaxWorkpaperBusinessActivityAnalysis",
      "TaxWorkpaperCchConfiguration",
      "TaxWorkpaperCharitableContribution",
      "TaxWorkpaperConsolidated1099",
      "TaxWorkpaperF1040",
      "TaxWorkpaperF1065SchK1",
      "TaxWorkpaperF1095a",
      "TaxWorkpaperF1098e",
      "TaxWorkpaperF1098t",
      "TaxWorkpaperF1099b",
      "TaxWorkpaperF1099div",
      "TaxWorkpaperF1099int",
      "TaxWorkpaperF1099oid",
      "TaxWorkpaperF1099q",
      "TaxWorkpaperF1099r",
      "TaxWorkpaperF1099ssa",
      "TaxWorkpaperF1120sSchK1",
      "TaxWorkpaperHomeownersExemptionFiling",
      "TaxWorkpaperInvestmentExpenses",
      "TaxWorkpaperManualExecution",
      "TaxWorkpaperManualInput",
      "TaxWorkpaperMonitor",
      "TaxWorkpaperPersonalPropertyTaxDeduction",
      "TaxWorkpaperRealPropertyAnalysis",
      "TaxWorkpaperReasonableCompensationAnalysis",
      "TaxWorkpaperReassessmentAppeal",
      "TaxWorkpaperSaleProjection",
      "TaxWorkpaperW2"
    ]
  }
};
      export default result;
    